<script setup>
import { defineProps } from 'vue'

const props = defineProps({
    resourceCardInfo: {
        type: Object,
        required: true
    }
})
</script>

<template>
    <a
        :href="props.resourceCardInfo.link"
        target="_blank"
    >
        <div class="resource-card">
            <h2 class="resource-card-title">
                {{ props.resourceCardInfo.text }}
            </h2>
            <div class="resource-card-info">
                <div class="resource-card-category">
                    Категория:
                    <span>{{ props.resourceCardInfo.tag.main_tag.name }}</span>
                </div>
                <div class="resource-card-date">
                    <img
                        src="/svg/calendar_date.svg"
                        alt="Календарь"
                    />
                    {{
                        new Date(
                            props.resourceCardInfo.creation_time
                        ).toLocaleDateString('ru-RU', {
                            day: 'numeric',
                            month: 'long',
                            year: 'numeric'
                        })
                    }}
                </div>
            </div>
        </div>
    </a>
</template>

<style scoped lang="scss">
a {
    text-decoration: none;
    color: unset;
}

.resource-card {
    height: 210px;
    background: #fff;
    border-radius: 5px;
    box-shadow: 1px 1px 50px 10px #2632380d;
    padding: 19px 10px;
}

.resource-card-title {
    height: 65%;
    display: flex;
    align-items: end;
    text-align: left;
    font-size: 17px;
    line-height: 25px;
    font-weight: 500;
}

.resource-card-info {
    display: flex;
    flex-direction: column;
    gap: 5px;
    font-size: 14px;
    line-height: 24px;
    font-weight: 400;
    color: #a2a2a2;
    margin-top: 10px;
}

.resource-card-category {
    text-align: left;

    span {
        color: #0635ac;
        cursor: pointer;

        &:hover {
            text-decoration: underline;
        }
    }
}

.resource-card-date {
    display: flex;
    align-items: center;
    gap: 5px;
}
</style>
